/**
 * Quick task 260729-cj9 — TanStack Query hook for the company-wide
 * watcher-candidates picker (Add watcher picker in TaskWatchersSection).
 *
 * Deliberately NOT project-scoped — backs the widened addWatcher policy
 * which accepts any active internal user, not just project members.
 * Debouncing keystroke → query is the picker component's responsibility.
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchWatcherCandidates,
  type WatcherCandidate,
} from '../services/api/watcherCandidates';

export interface UseWatcherCandidatesArgs {
  /** Substring filter; the picker debounces upstream. */
  query: string;
  /** Disable the fetch when the picker is closed. */
  enabled: boolean;
}

export function useWatcherCandidates({ query, enabled }: UseWatcherCandidatesArgs) {
  return useQuery<WatcherCandidate[]>({
    queryKey: ['watcher-candidates', query],
    queryFn: () => fetchWatcherCandidates(query),
    enabled,
    staleTime: 5_000,
    // Picker is ephemeral — let stale data surface immediately to keep keystrokes responsive.
    placeholderData: (prev) => prev,
  });
}
